import type { BrowserOptions } from '@sentry/react'

type BeforeSend = NonNullable<BrowserOptions['beforeSend']>

/**
 * Drop Sentry events that are noise: canceled fetches, ResizeObserver loop
 * errors, user-canceled Clerk flows. Apps can override this via InitSentryOptions.
 */
export const defaultBeforeSend: BeforeSend = (event, hint) => {
  const error = hint?.originalException
  const message = typeof error === 'object' && error && 'message' in error
    ? String((error as { message: unknown }).message)
    : ''

  if (message.includes('ResizeObserver loop')) return null
  if (message.includes('AbortError')) return null
  if (message.includes('The user aborted a request')) return null

  return event
}
